export const NOTIFICATIONS_QUERY = /* GraphQL */ `
  query Notifications($limit: Int) {
    notifications(limit: $limit) {
      id type title body targetUrl readAt createdAt
      sender { id name pictureUrl }
    }
    unreadNotificationCount
  }
`;

export const MARK_NOTIFICATION_READ = /* GraphQL */ `
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id)
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = /* GraphQL */ `
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead
  }
`;

export const SEND_TEST_NOTIFICATION = /* GraphQL */ `
  mutation SendTestNotification {
    sendTestNotification
  }
`;

export const REGISTER_PUSH_TOKEN = /* GraphQL */ `
  mutation RegisterPushToken($token: String!) {
    registerPushToken(token: $token)
  }
`;

export const UNREGISTER_PUSH_TOKEN = /* GraphQL */ `
  mutation UnregisterPushToken($token: String!) {
    unregisterPushToken(token: $token)
  }
`;

export const MY_PUSH_DEVICE_TYPES_QUERY = /* GraphQL */ `
  query MyPushDeviceTypes {
    myPushDeviceTypes
  }
`;

export const NOTIFICATION_ADDED_SUB = /* GraphQL */ `
  subscription OnNotificationAdded {
    onNotificationAdded {
      id type title body targetUrl readAt createdAt
    }
  }
`;

export const UNREAD_COUNT_SUB = /* GraphQL */ `
  subscription OnUnreadNotificationCountChanged {
    onUnreadNotificationCountChanged
  }
`;
